export const number_input = {    
    parts: ['field'],
    variants: {       
        flushed:{
            field:{
                rouned: 'sm',                
                shadow: 'none',
                borderBottomWidth: "1px",
                _focus: {
                    // bg: 'gray.50',
                    borderColor: 'brand.500',
                    shadow: 'none'
                },
                _placeholder:{
                    color: 'gray.300'
                },
                _disabled: {
                    color: 'gray.300',
                    _hover:{
                        cursor: 'not-allowed'
                    }

                }
            }
        }
    },
    defaultProps: {
        // focusBorderColor: 'brand.700',
    }
}

